export default __webpack_public_path__ + "static/inverstor-intelligence-v4-53c1976d17412ca455980de2a1e01d87.svg";